module.exports = __webpack_public_path__ + "assets1662726319812/img/lan5.01bd8a8d.png";